module.exports = __webpack_public_path__ + "static/media/icon-plus-main.fa5ce1a2.svg";